import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartService, CartItem } from '../../../core/services/shared/cart.service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-cart-drawer',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './cart-drawer.component.html',
  styleUrls: ['./cart-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartDrawerComponent {
  cartService = inject(CartService);

  toggle() {
    this.cartService.toggleCart();
  }

  close() {
    this.cartService.closeCart();
  }

  checkout() {
    alert('Checkout coming soon! Please contact sales to complete your purchase.');
  }

  increment(item: CartItem) {
    this.cartService.updateQuantity(item.productId, item.quantity + 1, item.size, item.color);
  }

  decrement(item: CartItem) {
    if (item.quantity > 1) {
      this.cartService.updateQuantity(item.productId, item.quantity - 1, item.size, item.color);
    } else {
      this.cartService.removeFromCart(item.productId, item.size, item.color);
    }
  }

  remove(item: CartItem) {
    this.cartService.removeFromCart(item.productId, item.size, item.color);
  }
}
